import React from "react";
import { useIntl } from "react-intl";

import { Text } from "../ui";
import { type TextProps } from "../ui/text/text";

import { useRelativeTime } from "./useRelativeTime";
import { dateFormatOptions, type TimeAgoVariant } from "./utils";

interface RelativeTimestampProps extends TextProps {
  timestamp: string;
  futureDate?: boolean;
  /**
   * "compact" (default): "5m", falling back to an absolute date after a week.
   * "suffixed": "5m ago", staying relative through months and years.
   */
  variant?: TimeAgoVariant;
}

export const RelativeTimestamp: React.FC<RelativeTimestampProps> = ({
  timestamp,
  futureDate = false,
  variant = "compact",
  theme = "inherit",
  ...textProps
}) => {
  const intl = useIntl();
  const relativeTime = useRelativeTime(timestamp, { futureDate, variant });
  const date = new Date(timestamp);

  return (
    <Text
      {...textProps}
      theme={theme}
      tag="time"
      title={intl.formatDate(date, dateFormatOptions)}
    >
      {relativeTime}
    </Text>
  );
};

export default RelativeTimestamp;
